import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Bell = ({
  size,
  type,
  theme,
  className,
  dataTestId = "bell-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.557 1.773a1.51 1.51 0 0 1 2.885 0 3.16 3.16 0 0 1 2.222 2.618l.652 4.654a1.704 1.704 0 0 0 1.058 1.366l.073.029a1.37 1.37 0 0 1-.511 2.643H10.37l-.28.987-.013.03a1.884 1.884 0 0 1-1.747 1.182h-.66c-.77 0-1.46-.469-1.748-1.181l-.012-.03-.281-.988H3.064c-.612 0-1.13-.401-1.306-.956m11.178-.268a.146.146 0 0 0 .147-.146.15.15 0 0 0-.094-.138l-.07-.028a2.94 2.94 0 0 1-1.817-2.343L10.45 4.55a1.936 1.936 0 0 0-1.385-1.613 1.121 1.121 0 0 1-.787-.784.287.287 0 0 0-.557 0c-.11.42-.444.686-.785.785A1.934 1.934 0 0 0 5.55 4.55l-.002.007-.65 4.647a2.933 2.933 0 0 1-1.82 2.343l-.003.002-.066.026h-.001a.15.15 0 0 0-.085.18c.02.062.076.104.14.104h9.872ZM6.9 13.083l.167.585a.66.66 0 0 0 .602.39h.66a.66.66 0 0 0 .6-.39l.167-.585H6.901Zm-.344-11.31a3.173 3.173 0 0 0-2.02 1.845v.003a3.17 3.17 0 0 0-.2.77l-.652 4.646v.007a1.71 1.71 0 0 1-1.059 1.367l-.067.026-.004.002a1.374 1.374 0 0 0-.798 1.689"
    />
  </SVGIcon>
);
